import EvidendeIndicator from "../../evidence/EvidenceIndicator";
import GhostInfoSection from "../GhostInfoSection";
import SanityIndicator from "../SanityIndicator";
import SpeedIndicator, { speedExactly, speedOr } from "../SpeedIndicator";
import SpeedSymbol from "../SpeedSymbol";

export default function Gallu() {
    return (
        <div>
            <div className="ghost-details">
                <GhostInfoSection title="Evidence">
                    <ul className="list-unstyled">
                        <li><EvidendeIndicator evidenceType="EMF 5" /></li>
                        <li><EvidendeIndicator evidenceType="Ultraviolet" /></li>
                        <li><EvidendeIndicator evidenceType="Spirit Box" /></li>
                    </ul>
                </GhostInfoSection>
                <GhostInfoSection title="Special Ability">
                    The Gallu has three states:
                    <ol>
                        <li>weakened</li>
                        <li>normal</li>
                        <li>enraged</li>
                    </ol>

                    It will go to a higher state
                    <ul>
                        <li>instantly after <strong>burning a crucifix</strong> or <strong>smudging it</strong> <em>outside of a hunt</em></li>
                        <li>instantly after the end of the incense's blinding effect <em>during a hunt</em></li>
                        <li>3 seconds after stepping in <strong>salt</strong> when it is in <em>weakened</em> state</li>
                        <li>2 seconds after stepping in <strong>salt</strong> when it is in <em>normal</em> state</li>
                    </ul>

                    <div><strong>Note:</strong> The Gallu cannot disturb salt while it's <em>enraged</em>.</div>
                </GhostInfoSection>
                <GhostInfoSection title="Hunt">
                    If the Gallu ends its hunt in an enraged state, it will drop to the weakened state.
                    <ul>
                        <li>
                            In its <strong>normal</strong> state the Gallu has a normal behavior 
                            and hunts at <GalluSanityIndicator which="normal" />. Its speed is normal at 
                            <GalluSpeedIndicator which="normal" />.
                            <strong>Incense</strong> blinding is at 5 seconds.
                        </li>
                        <li>
                            In its <strong>enraged</strong> state it hunts at 
                            <GalluSanityIndicator which="enraged" /> and the 
                            crucifix has -2 meters range. It's also slower with 
                            <GalluSpeedIndicator which="weakened" />.
                            <strong>Incense</strong> blinding is even 6 seconds.
                        </li>
                        <li>
                            In its <strong>weakened</strong> state it hunts at 
                            <GalluSanityIndicator which="weakened" /> and the 
                            crucifix has +1 meters range. It's also faster with 
                            <GalluSpeedIndicator which="enranged" />.
                            <strong>Incense</strong> blinding is only 4 seconds.
                        </li>
                    </ul>
                </GhostInfoSection>
            </div>
        </div>
    );
}

export function GalluSanityIndicator({ which }: { which?: 'normal' | 'weakened' | 'enraged' }) {
    return (
        <>
        {which === 'normal' && <SanityIndicator sanity={50} />}
        {(!which?.length || which === 'weakened') && <SanityIndicator sanity={40} tooltip="when weakened" />}
        {(!which?.length || which === 'enraged') && <SanityIndicator sanity={60} tooltip="when enraged" />}
        </>
    );
}

export function GalluSpeedIndicator({ which }: { which?: 'normal' | 'weakened' | 'enranged' }) {
    const norm = speedExactly(1.7);
    const slow = speedExactly(1.36);
    const fast = speedExactly(1.96);

    return (
        <>
        {which === 'normal' && <SpeedSymbol speed={1.71} description="normal state" speedingUp />}
        {(!which?.length || which === 'weakened') && <SpeedSymbol speed={1.36} description="weakened state" speedingUp />}
        {(!which?.length || which === 'enranged') && <SpeedSymbol speed={1.96} description="enranged state" speedingUp />}
        <SpeedIndicator speed={speedOr(speedOr(norm, slow), fast)} />
        </>
    );
}